import axios from 'axios'
import errorHandeler from '../error/index'
import setRequestConfig from '@/utils/setRequestConfig'
import * as api from '@/api/api'

axios.defaults.withCredentials = true
axios.defaults.timeout = 40000
axios.defaults.headers = {
  'Content-Type': 'application/x-www-form-urlencoded'
}

// Add a request interceptor 请求拦截
axios.interceptors.request.use(function (config) {
  // 图片上传
  let isUploadImg = Object.prototype.toString.call(config.data) === '[object FormData]'
  if (config.method === 'post' && isUploadImg) {
    config.data.append('_t', Date.parse(new Date()) / 1000)
  } else if (config.method === 'post' && !isUploadImg) {
    config.data += '&_t=' + Date.parse(new Date()) / 1000
  } else if (config.method === 'get') {
    config.params = {
      _t: Date.parse(new Date()) / 1000,
      ...config.params
    }
  } else {
  }
  // console.log(config)
  return setRequestConfig(config)
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor 响应拦截
axios.interceptors.response.use(function (response) {
  if (response.data.state === 'nologin') {
    window.location.href = api.isDev ? './login.html' : './login.aspx'
  }
  return response
}, function (error) {
  // Do something with response error
  return Promise.reject(error)
})

export const http = {
  get (url, config) {
    return new Promise((resolve, reject) => {
      axios.get(url, config)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          const data = creatErrorData(err, url)
          resolve(data)
          errorHandeler(err)
        })
    })
  },
  post (url, params, config) {
    return new Promise((resolve, reject) => {
      axios.post(url, params, config)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          const data = creatErrorData(err, url)
          resolve(data)
          errorHandeler(err)
        })
    })
  }
}
function creatErrorData (err, url) {
  const data = {
    state: 'error',
    msg: 'error',
    err,
    url
  }
  if (err) {
    let msg = `Network Error `
    if (err.response) {
      msg += `${err.response.status} ${err.message}`
    } else if (err.request) {
      msg += `${err.request.status} Requset Fail  ${err.message}`
    } else {
      msg = err.message
    }
    data.msg = msg
  }
  return data
}
export const install = function (Vue) {
  if (!Vue.prototype.$http) {
    Vue.prototype.$http = http
  }
}
export default install



// WEBPACK FOOTER //
// ./src/api/http.js